module.exports = __webpack_public_path__ + "static/img/mole.3edfca00.png";